import { isObscuredCNPJ, isObscuredCPF } from '@woovi/utils';

import { TAXID_TYPE } from './TaxIDSchema.ts';

export const getObscuredTaxIDType = (taxID: string): string | null => {
  if (isObscuredCNPJ(taxID)) {
    return TAXID_TYPE.BR_CNPJ;
  }

  if (isObscuredCPF(taxID)) {
    return TAXID_TYPE.BR_CPF;
  }

  return null;
};
